import { EnvSettingsData } from "../types";

export type getEnvSettingsResponse = EnvSettingsData;

export function getEnvSettings(): getEnvSettingsResponse {
  console.log("process.env.REACT_APP_API_URL", process.env.REACT_APP_API_URL);
  console.log(
    "process.env.REACT_APP_API_INTERNAL_URL",
    process.env.REACT_APP_API_INTERNAL_URL
  );
  return {
    API_URL: process.env.REACT_APP_API_URL || "http://localhost:3000/api",
    API_INTERNAL_URL:
      process.env.REACT_APP_API_INTERNAL_URL || "http://localhost:5050/api",

    REACT_APP_FB_API_KEY: process.env.REACT_APP_FB_API_KEY || "",
    REACT_APP_FB_AUTH_DOMAIN: process.env.REACT_APP_FB_AUTH_DOMAIN || "",
    REACT_APP_FB_PROJECT_ID: process.env.REACT_APP_FB_PROJECT_ID || "",
    REACT_APP_FB_STORAGE_BUCKET: process.env.REACT_APP_FB_STORAGE_BUCKET || "",
    REACT_APP_FB_MESSAGING_SENDER_ID:
      process.env.REACT_APP_FB_MESSAGING_SENDER_ID || "",
    REACT_APP_FB_APP_ID: process.env.REACT_APP_FB_APP_ID || "",
    REACT_APP_FB_MEASUREMENT_ID: process.env.REACT_APP_FB_MEASUREMENT_ID || "",
  };
}
